
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformSucessResponse, transformErrorResponse } from '../../../utils/API/responseMiddleware'
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";


const verifiedCompetencyListApi = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'verifiedCompetencyListApi',
    endpoints: (builder) => ({
        getAllCompetencyListForAllMember: builder.mutation({
            query: (details) => ({
                url: '/GMDC/GetAllCompetencyListForAllMember',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getGMAPMemberByGMPNumberOrName: builder.mutation({
            query: (details) => ({
                url: '/GMDC/GetGMAPMemberByGMPNumberOrName',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addCompetencyForMemberByAdmin: builder.mutation({
            query: (details) => ({
                url: '/GMDC/AddCompetencyForMemberByAdmin',
                method: 'POST',
                body: transformRequest(details,"create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCompetencyDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMDC/getCompetencyDetailsById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCompetencyDetailsByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMDC/GetCompetencyDetailsByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        setCompentancyVisibleByMemberId: builder.mutation({
            query: (details) => ({
                url: '/GMDC/SetCompentancyVisibleByMemberId',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        verifiedCompetencyRejectOrApprove: builder.mutation({
            query: (details) => ({
                url: '/GMDC/VerifiedCompetencyRejectOrApprove',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateVerifiedCompetency: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/UpdateVerifiedCompetency',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetAllCompetencyListForAllMemberMutation,
    useGetGMAPMemberByGMPNumberOrNameMutation,
    useAddCompetencyForMemberByAdminMutation,
    useLazyGetCompetencyDetailsByIdQuery,
    useLazyGetCompetencyDetailsByMemberIdQuery,
    useSetCompentancyVisibleByMemberIdMutation,
    useVerifiedCompetencyRejectOrApproveMutation,
    useUpdateVerifiedCompetencyMutation
} = verifiedCompetencyListApi;

export default verifiedCompetencyListApi;